import { createFileRoute } from "@tanstack/react-router";
import { FileText } from "lucide-react";

import { PagesWorkspace } from "@/components/pages/pages-workspace";

const Pages = () => (
  <PagesWorkspace>
    <div className="flex min-h-80 flex-col items-center justify-center gap-3 rounded-2xl border border-dashed text-muted-foreground">
      <FileText aria-hidden className="size-6" />
      <p className="text-sm">Choose a page to edit.</p>
    </div>
  </PagesWorkspace>
);

export const Route = createFileRoute("/admin/pages/")({
  component: Pages,
});
